import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { OfferingDocumentType } from '@arrived/models';

export const formatOfferingDocumentType = (type: string | OfferingDocumentType | undefined): ReactNode => {
  switch (type) {
    case OfferingDocumentType.OFFERING_CIRCULAR:
      return <FormattedMessage id="offering-document-offering-circular" defaultMessage="Offering Circular" />;

    case OfferingDocumentType.RISK_FACTORS:
      return <FormattedMessage id="offering-document-risk-factors" defaultMessage="Risk Factors" />;

    case OfferingDocumentType.SERIES_OVERVIEW:
      return <FormattedMessage id="offering-document-series-overview" defaultMessage="Series Overview" />;

    case OfferingDocumentType.USE_OF_PROCEEDS:
      return <FormattedMessage id="offering-document-use-of-proceeds" defaultMessage="Use of Proceeds" />;

    case OfferingDocumentType.FORM_1K:
      return <FormattedMessage id="offering-document-form-1k" defaultMessage="Full-Year Property Financials" />;

    case OfferingDocumentType.FORM_1SA:
      return <FormattedMessage id="offering-document-form-1sa" defaultMessage="Half-Year Property Financials" />;

    default:
      return '';
  }
};
